import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import TranslateCloud from "./components/TranslateCloud";
import Pricing from "./components/Pricing";
import Testimonials from "./components/Testimonials";
import CTA from "./components/CTA";
import Footer from "./components/Footer";
import SchemaOrg from "../../components/SchemaOrg";

export default function Home() {
  return (
    <div className="relative bg-[#f8f9fb]">
      <SchemaOrg />
      <Header />
      <main>
        <Hero />
        <Services />
        <TranslateCloud />
        <Pricing />
        <Testimonials />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
